import { Label, LabelMap } from '../../../../../../../common/labels/labelTypes';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLabels, selectLabelPaths } from '../../../../../../element/labels/labelSelectors';
import { UseLabelPopupsStateReturn } from '../labelComponentPropTypes';

const useLabelPopupsState = (toggleEditMenu: (isOpen: boolean) => void): UseLabelPopupsStateReturn => {
    const [currentlyEditingLabelId, setCurrentlyEditingLabelId] = useState<string | null>(null);
    const [showColorChange, setShowColorMenu] = useState<boolean>(false);

    const rootPaths = useSelector(selectLabelPaths);
    const { userRootPath, shareRootPath } = rootPaths || {};

    const labels: LabelMap | undefined = useSelector(selectLabels);
    const currentlyEditingLabel = labels?.[currentlyEditingLabelId || ''] || null;

    const allLabels = Object.values(labels || {});

    const handleClickEdit = (label: Label) => {
        const isOpeningPopup = currentlyEditingLabelId !== label.id;
        setCurrentlyEditingLabelId(isOpeningPopup ? label.id : null);
        toggleEditMenu(isOpeningPopup);
        if (currentlyEditingLabelId !== label.id) {
            setShowColorMenu(false);
        }
    };

    const handleClickColorChange = () => {
        setShowColorMenu(!showColorChange);
    };

    return {
        allLabels,
        currentlyEditingLabel,
        userRootPath,
        shareRootPath,
        handleClickEdit,
        showColorChange,
        handleClickColorChange,
    };
};

export default useLabelPopupsState;
